export const SinkIcon = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M2885 5106 c-229 -53 -419 -208 -515 -420 -52 -115 -61 -171 -67
-420 l-6 -228 -91 91 c-103 102 -154 130 -235 131 -84 0 -130 -18 -186 -75
-54 -54 -75 -102 -75 -175 0 -96 11 -112 214 -317 l189 -192 -634 -3 c-629 -3
-634 -3 -675 -25 -56 -30 -108 -91 -132 -154 -11 -30 -165 -448 -343 -929
l-324 -875 0 -665 c0 -661 0 -665 21 -705 12 -22 35 -53 50 -69 16 -15 47 -38
69 -50 l40 -21 2345 -3 c1689 -2 2359 0 2397 8 61 13 132 70 166 134 l22 41 0
665 0 665 -338 913 c-185 503 -344 926 -351 940 -21 39 -75 88 -121 109 -37
17 -92 18 -684 23 l-643 5 -15 45 c-19 55 -70 135 -112 174 l-31 30 0 345 c0
390 2 398 76 459 96 80 240 57 310 -48 22 -33 28 -57 35 -136 6 -74 14 -105
35 -144 45 -83 123 -130 216 -130 77 0 120 15 171 60 71 62 87 106 87 232 0
209 -65 365 -214 513 -99 98 -177 146 -301 185 -90 28 -264 36 -350 16z m279
-176 c107 -27 169 -63 252 -145 113 -111 164 -233 164 -391 0 -77 -2 -84 -26
-103 -37 -29 -85 -27 -114 4 -19 20 -24 40 -30 114 -10 113 -40 183 -112 254
-186 186 -482 139 -609 -95 l-34 -63 -5 -334 -5 -335 -73 1 c-44 1 -79 6 -89
14 -13 12 -15 49 -10 319 5 334 9 360 69 480 44 87 142 184 234 233 130 67
251 82 388 47z m-1001 -998 l159 -158 -60 -61 -61 -60 -160 162 c-175 176
-185 192 -140 249 16 20 29 26 62 26 39 0 46 -5 200 -158z m479 -278 c103 -35
170 -129 171 -239 0 -80 -25 -136 -83 -188 -101 -91 -239 -91 -340 0 -58 52
-83 108 -83 188 1 175 170 296 335 239z m-482 -381 c10 -29 28 -66 40 -83 l21
-30 -610 0 -610 0 -26 -22 c-21 -18 -83 -175 -301 -763 -151 -406 -274 -750
-274 -763 0 -12 11 -34 25 -47 l24 -25 2111 0 2111 0 24 25 c14 13 25 35 25
48 0 39 -546 1497 -569 1521 -21 21 -25 21 -637 24 l-615 2 21 30 c12 17 30
54 40 83 l18 52 626 3 625 2 25 -22 c20 -18 100 -227 361 -934 184 -500 335
-920 335 -932 0 -13 -11 -34 -25 -47 l-24 -25 -2341 0 -2341 0 -24 25 c-14 13
-25 34 -25 47 0 12 151 432 335 932 261 707 341 916 361 934 l25 22 625 -2
626 -3 18 -52z m1850 -713 l0 -430 -1450 0 -1450 0 0 430 0 430 1450 0 1450 0
0 -430z m-3120 -669 c-27 -95 -51 -175 -53 -178 -3 -2 -54 -2 -115 -1 l-111 3
73 195 c40 107 113 303 162 435 l89 240 3 -260 2 -260 -50 -174z m3459 253
l159 -429 -110 -3 c-61 -1 -112 -1 -115 1 -2 3 -26 83 -53 178 l-50 174 0 259
c0 143 2 257 5 254 3 -3 77 -198 164 -434z m-2271 -241 c-26 -52 -29 -66 -25
-125 l4 -68 -518 0 c-286 0 -519 3 -519 7 0 10 61 226 67 236 2 4 233 7 512 7
l508 0 -29 -57z m625 41 c82 -21 128 -46 167 -90 27 -31 31 -43 26 -72 -11
-74 -4 -72 -336 -72 -332 0 -325 -2 -336 72 -5 29 -1 41 26 72 18 20 47 44 64
53 96 51 272 68 389 37z m1359 -84 c15 -52 30 -107 33 -122 l7 -28 -520 0
-519 0 4 68 c4 59 2 73 -25 125 l-29 57 511 -2 510 -3 28 -95z m-1502 -665
c1273 0 2332 3 2353 7 l37 7 0 -490 0 -491 -29 -29 -29 -29 -2332 0 -2332 0
-29 29 -29 29 0 491 0 490 38 -7 c20 -4 1079 -7 2352 -7z"
      />
      <path
        d="M394 760 c-48 -19 -54 -44 -54 -208 l0 -154 29 -29 29 -29 192 0
c236 0 260 8 260 91 0 18 -10 39 -25 54 -23 24 -28 25 -170 25 l-145 0 0 104
c0 104 0 104 -31 130 -32 27 -50 30 -85 16z"
      />
    </g>
  </svg>
);
